<template>
  <div class="checklist-item">
    <v-list-item density="compact" slim>
      <template #prepend>
        <v-list-item-action>
          <v-checkbox-btn
            :id="checkboxId"
            v-model="ticked"
            color="primary"
            :disabled="disabled"
            density="compact"
          ></v-checkbox-btn>
        </v-list-item-action>
      </template>
      <div id="checklist-item-text" @click="onTextClicked">
        <stb-markdown class="item-text" :source="label" @markdown-error="onMarkdownError" />
      </div>
    </v-list-item>
    <checklist-item-comment
      :checklist-item="checklistItem"
      :comment-btn-id="commentId"
      :comment-disabled="disabled"
      class="checklist-item-comment"
    >
    </checklist-item-comment>
  </div>
</template>
<script>
import ChecklistItemComment from './ChecklistItemComment';
import StbMarkdown from './StbMarkdown';

export default {
  name: 'CompleteChecklist',
  components: {
    ChecklistItemComment,
    StbMarkdown
  },
  props: {
    modelValue: { type: Boolean, required: false, default: false },
    checklistItem: { type: Object, required: false, default: () => ({}) },
    disabled: { type: Boolean, required: false, default: false },
    checkboxId: { type: String, required: false, default: '' },
    commentId: { type: String, required: false, default: '' },
    label: { type: String, required: false, default: '' }
  },

  emits: ['update:modelValue', 'markdownError'],

  data() {
    return {
      ticked: this.modelValue,
      markdownError: false
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.ticked = value;
      }
    },
    ticked(value) {
      this.$emit('update:modelValue', value);
    }
  },
  mounted() {
    this.ticked = this.modelValue;
  },
  methods: {
    onMarkdownError() {
      this.markdownError = true;
      this.$emit('markdownError');
    },
    onTextClicked() {
      if (this.disabled) {
        return;
      }
      this.ticked = !this.ticked;
    }
  }
};
</script>
<style scoped>
.checklist-item .v-list-item {
  height: auto;
  align-items: flex-start;
  padding: 0px !important;
}

.checklist-item-comment {
  padding-left: 6px;
  padding-bottom: 16px;
}
</style>
